import React from "react";
import {Form, Input, Button} from 'antd';
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { authLogin } from "../store/actions/auth";
import {
UserOutlined, LockOutlined
} from '@ant-design/icons';
// import {openNotificationWithIcon} from "./Function";

class LoginForm extends React.Component {
  state = {
    username: "",
    password: "",
    loadings: false,
  };

  onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  render() {
    const { error, loading, token } = this.props;
      if (token) {
        localStorage.setItem("currentSelectedKeys", JSON.stringify(['2']))
        return (
            (<Redirect to="/danhsachyeucau" />))
      }
      // 200424 Sử dụng cho web chính
      else {
        window.location.href ="https://homepage.rainscales.com.vn/logout"
        return false
      }

    const { loadings } = this.state;
    const onFinish = (values) => {
    this.props.login(values.username, values.password);
  };
    const error_sv = localStorage.getItem('error_s')
    if (error_sv) {
      localStorage.removeItem('error_s');
    }
    return (<>
          <Form
      name="normal_login"
      className="login-form"
      initialValues={{
        // username:'',
        // password:'',
        // remember: true,
      }}
      onFinish={onFinish}
    >{error && <p>{this.props.error.message}</p>}
      <Form.Item
        name="username"
        rules={[
          {
            required: true,
            message: 'Vui lòng nhập tên đăng nhập!',
          },
        ]}
      >
        <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Tên đăng nhập" autoComplete={'username'}/>
      </Form.Item>
      <Form.Item
        name="password"
        rules={[
          {
            required: true,
            message: 'Vui lòng nhập mật khẩu!',
          },
        ]}
      >
        <Input
          prefix={<LockOutlined className="site-form-item-icon" />}
          type="password"
          placeholder="Mật khẩu"
          autoComplete={'current-password'}
        />
      </Form.Item>
      <Form.Item>
        {/*<Form.Item name="remember" valuePropName="checked" noStyle>*/}
        {/*  <Checkbox>Ghi nhớ đăng nhập</Checkbox>*/}
        {/*</Form.Item>*/}

        <a className="login-form-forgot" href="/">
          Quên mật khẩu
        </a>
      </Form.Item>

      <Form.Item>

        <Button type="primary" danger htmlType="submit" className="login-form-button" loading={loading} onClick={() => loadings}>
          Đăng nhập
        </Button>
        {/* <Button type="danger" htmlType="submit" className="login-form-button" loading={loading} onClick={() => openNotificationWithIcon('error','Cảnh báo', "Bạn vui lòng đăng nhập trên trang chủ https://homepage.rainscales.com.vn/.")}>
          Đăng nhập
        </Button> */}
      </Form.Item>
    </Form>
    </>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    token: state.auth.token
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login: (username, password) => dispatch(authLogin(username, password))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm);
